import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const CustomerBankData = lazy(
  () =>
    import('./CustomerBankData.eager').then(mod => ({
      default: mod.CustomerBankData,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
